import { render, staticRenderFns } from "./generalStructure.vue?vue&type=template&id=953581d4&scoped=true"
import script from "./generalStructure.vue?vue&type=script&lang=js"
export * from "./generalStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953581d4",
  null
  
)

export default component.exports